export enum NoteTypes {
  SET_LOADING_NOTES='SET_LOADING_NOTES',
  LIST_NOTES='LIST_NOTES',
  LOGOUT='LOGOUT',
}